import { type InoltroDTO } from '@framework/api-client/api/inquiries-compile/schemas/inoltroDTO.ts';
import { DividerTitleElement } from '@framework/ui/components/text/DividerTitleElement.tsx';
import { Typography } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CommunicationAttachments } from './CommunicationAttachments.tsx';
import { CommunicationForwardContainer } from './CommunicationForwardContainer.tsx';

const TextWrapper = styled.div`
  min-height: 4px;
`;

export interface ICommunicationForwardViewProps {
  forward: InoltroDTO | null | undefined;
}

/**
 * Comunicazione inoltrata
 */
export function CommunicationForwardView(
  props: ICommunicationForwardViewProps,
) {
  const { forward } = props;

  const { t } = useTranslation();
  const messageRows = useMemo(
    () => forward?.messaggio?.split('\n') ?? [],
    [forward?.messaggio],
  );

  const attachments = useMemo(
    () => forward?.allegati?.map(a => a.allegato) ?? [],
    [forward?.allegati],
  );

  if (!forward) {
    return null;
  }

  return (
    <CommunicationForwardContainer>
      <DividerTitleElement
        title={t('communication-forward.title', 'Comunicazione Inoltrata')}
      />
      {messageRows.map((row, index) => (
        <TextWrapper key={index}>
          <Typography.Text>{row}</Typography.Text>
        </TextWrapper>
      ))}
      <div>
        <CommunicationAttachments attachments={attachments} />
      </div>
    </CommunicationForwardContainer>
  );
}
